var TEMPLATE_URL = require('./folder.listitem.html');
angular.module('ikeweb.folders').directive('folderListitem', ['$timeout', 'billingService',
    function($timeout, billingService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            transclude: true,
            scope: {
                folder: '=',
                selected: '=selectedFolder',
                select: '&',
                captureDropped: '&',
                folders: '='
            },
            controller: 'FolderListitemController',
            link: function(scope, element, attrs) {
                var input = element.find('.FolderListitem-name');
                scope.focus = function() {
                    $timeout(function() {
                        input[0].focus();
                    });
                };

                scope.canMakeSubFolder = false;
                billingService.isOnPremium().then(function(isPro) {
                    scope.canMakeSubFolder = isPro;
                });

                scope.selectText = function() {
                    input[0].select();
                };

                input.bind('keypress', function(event) {
                    if (event.which === 13) {
                        input.blur();
                    }
                });

                function acceptCapture($draggable) {
                    var capture = $draggable.data('capture');
                    return capture && !capture.isInFolder(scope.folder);
                }

                element.droppable({
                    addClasses: false,
                    accept: acceptCapture,
                    hoverClass: 'FolderListitem-dragover',
                    tolerance: 'pointer'
                });


                element.on('drop', function(evt, ui) {
                    ui.helper.data('dropped', true);
                    scope.captureDropped({
                        folder: scope.folder,
                        capture: ui.draggable.data('capture')
                    });
                });

            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folder.listitem.directive.js
// module id = 448
// module chunks = 0